/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import UilPrint from '@iconscout/react-unicons/icons/uil-print';

function PrintButton({ handlePrintCertificate, hanldePrintSamples, selectedRows }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    if (selectedRows.length === 0) {
      message.warning('Please select at least one card to print.');
      return;
    }
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setIsModalVisible(false);
    await handlePrintCertificate(); // Trigger the actual print logic
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };


  return (
    <>
      <Button
        type="primary"
        className="flex text-center h-auto items-center"
        onClick={showModal}
        disabled={selectedRows.length < 1}
      >
        <UilPrint /> &nbsp;&nbsp; Print Cards &nbsp;
      </Button>
      <Button
        type="primary"
        className="flex text-center h-auto items-center"
        onClick={() => {
          if (hanldePrintSamples) hanldePrintSamples()
        }}
        disabled={selectedRows.length < 1}
      >
        <UilPrint /> &nbsp;&nbsp; Print Samples &nbsp;
      </Button>

      <Modal
        title="Confirm Print"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes, Print"
        cancelText="Cancel"
      >
        <p>Are you sure you want to print the selected cards?</p>
      </Modal>
    </>
  );
}

export default PrintButton;
